import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=02c03fc0&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=js&"
export * from "./VideoForm.vue?vue&type=script&lang=js&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=02c03fc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c03fc0",
  null
  
)

export default component.exports